<template>
	<div class="page-home">
		<p style="text-align:center; padding-top: 100px; padding-bottom: 200px;">
			正在加载...
		</p>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'home',
	computed: {
		...mapGetters({
			role: 'getRole'
		})
	},
	created: function () {
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Home.vue?3e381f42